import {
	selectOrderBookingData,
	selectOrderDetail,
	updateByPass,
	useOrderState,
} from 'entities/orders';
import { selectDisableBookingTime } from 'entities/toolbar/timeslots';
import { useBookingSlots } from 'features/booking/slots';
import { FC, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';
import { ButtonToggle } from 'shared/ui/buttons/buttonToggle';
import { Confirm } from 'shared/ui/confirm';
import { ModalProvider } from 'shared/ui/modal';

interface BookingManualOrderProps {}

export const BookingManualOrder: FC<BookingManualOrderProps> = () => {
	const dispatch = useAppDispatch();
	const isChecked = useAppSelector(selectOrderBookingData)?.bypass;
	const disableBookingTime = useAppSelector(selectDisableBookingTime);
	const [openConfirm, setOpenConfirm] = useState(false);
	const orderDetail = useAppSelector(selectOrderDetail);
	const { isVisitProgress } = useOrderState(orderDetail);
	const { setCurrentActive } = useBookingSlots();

	const handleBookingChange = () => {
		setOpenConfirm(false);
		setCurrentActive('');
		dispatch(updateByPass({ isByPass: !isChecked }));
	};

	const toggleOpenConfirm = () => {
		setOpenConfirm(prev => !prev);
	};

	if ((!disableBookingTime && !isChecked) || isVisitProgress) {
		return null;
	}

	return (
		<>
			{openConfirm && (
				<ModalProvider openByDefault>
					<Confirm
						title={
							!isChecked
								? 'Действительно отключить все правила для этого бронирования?'
								: 'Данное действие применит все правила для бронирования. Выбранный слот может стать недоступным. Продолжить?'
						}
						cancelButtonLabel={
							!isChecked ? 'Нет, продолжить с проверками' : 'Нет'
						}
						confirmButton={
							<ButtonContained onClick={handleBookingChange}>
								{!isChecked ? 'Да, отключить' : 'Да'}
							</ButtonContained>
						}
						onClose={toggleOpenConfirm}
					/>
				</ModalProvider>
			)}

			<ButtonToggle onClick={toggleOpenConfirm} isChecked={isChecked}>
				Ручное бронирование
			</ButtonToggle>
		</>
	);
};
